import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=18c69bcc&scoped=true&"
import script from "./ChangeLog.vue?vue&type=script&lang=js&"
export * from "./ChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLog.vue?vue&type=style&index=0&id=18c69bcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c69bcc",
  null
  
)

export default component.exports